import { ChangePasswordForm } from "@/features/user/forms/change-password-form";
import { appTitleHead } from "@/lib/app-document-title";
import { useTranslation } from "@/lib/i18n/client";
import { createFileRoute } from "@tanstack/react-router";
import { useLng } from "@/hooks/use-lng";

export const Route = createFileRoute("/_app/account/_auth/password")({
  head: () => appTitleHead("account-password-title"),
  component: PasswordPage
});

function PasswordPage() {
  const lng = useLng();
  const { t } = useTranslation(lng, "translation");
  return (
    <div className="flex h-full flex-col justify-between">
      <h1 className="hidden text-left md:block">{t("password-header")}</h1>
      <p>{t("password-description")}</p>
      <ChangePasswordForm />
    </div>
  );
}
